var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPropertyWalkthrough(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 214,
    viewBox: "0 0 274 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_93_55)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_55)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.47715 6.47715 1 12 1H262C267.523 1 272 5.47715 272 11V211H2V11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M258.531 -3H16.4687C5.16413 -3 -4 5.82384 -4 16.7086V166.291C-4 177.176 5.16413 186 16.4687 186H258.531C269.836 186 279 177.176 279 166.291V16.7086C279 5.82384 269.836 -3 258.531 -3Z",
    fill: "#1467B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05985 211H265.94C278.118 211 288 200.963 288 188.592V179H-17V188.592C-17 200.963 -7.11839 211 5.05985 211Z",
    fill: "#9FC1DF",
    fillOpacity: 0.89
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257.364 175.825C257.364 175.825 257.334 175.825 257.319 175.825C256.865 171.745 253.405 168.572 249.205 168.572C247.331 168.572 245.609 169.207 244.234 170.265C244.279 169.842 244.31 169.418 244.31 168.995C244.31 166.986 243.781 165.082 242.859 163.45C243.312 162.091 243.554 160.625 243.554 159.114C243.554 151.499 237.375 145.319 229.76 145.319C222.145 145.319 215.965 151.499 215.965 159.114C209.71 159.114 204.648 164.176 204.648 170.431C204.648 171.292 204.739 172.123 204.92 172.924C204.829 172.924 204.739 172.924 204.648 172.924C201.687 172.924 199.088 174.495 197.668 176.867C197.23 176.792 196.776 176.746 196.308 176.746C191.805 176.746 188.149 180.403 188.149 184.905H265.478C265.508 184.603 265.523 184.301 265.523 183.999C265.523 179.496 261.866 175.84 257.364 175.84V175.825Z",
    fill: "#1467B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5297 173.573C14.5297 173.573 14.56 173.573 14.5902 173.573C15.0888 169.056 18.9114 165.551 23.5499 165.551C25.6199 165.551 27.5236 166.246 29.0496 167.424C29.0043 166.956 28.9741 166.502 28.9741 166.019C28.9741 163.798 29.5633 161.698 30.5757 159.885C30.077 158.374 29.8051 156.772 29.8051 155.095C29.8051 146.679 36.6344 139.85 45.0502 139.85C53.466 139.85 60.2954 146.679 60.2954 155.095C67.2002 155.095 72.8057 160.7 72.8057 167.605C72.8057 168.557 72.7 169.464 72.5035 170.355C72.6093 170.355 72.7 170.355 72.8057 170.355C76.0844 170.355 78.94 172.093 80.5265 174.707C81.01 174.631 81.5086 174.586 82.0223 174.586C87.0083 174.586 91.0424 178.62 91.0424 183.606H5.57001C5.53979 183.274 5.50958 182.941 5.50958 182.609C5.50958 177.623 9.54373 173.589 14.5297 173.589V173.573Z",
    fill: "#1467B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M236.664 80.0781H45.4128V184.452H236.664V80.0781Z",
    fill: "#90ADFC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236.664 173.558H45.2769V184.331H236.664V173.558Z",
    fill: "#9FAFFF"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.243 16.7556H94.1851V54.3774H111.243V16.7556Z",
    fill: "#3E519E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M247.316 80.5313H34.8818L46.3194 61.2672H235.894L247.316 80.5313Z",
    fill: "#3E519E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M208.168 43.1513H73.9237V184.452H208.168V43.1513Z",
    fill: "#C5CDFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M219.591 62.4004H62.4861L73.9237 43.1513H208.153L219.591 62.4004Z",
    fill: "#5363BC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.661 118.047V81.9214H94.1851V118.047H113.661Z",
    fill: "#9FAFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M111.243 84.3389H96.6026V113.197H111.243V84.3389Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.664 96.3507H95.0765V97.7558H112.664V96.3507Z",
    fill: "#9FAFFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.012 83.2964H100.682V97.4536H102.012V83.2964Z",
    fill: "#9FAFFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.617 83.2964H106.288V97.4536H107.617V83.2964Z",
    fill: "#9FAFFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M115.912 118.093H91.9489V122.474H115.912V118.093Z",
    fill: "#E6EAFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M115.912 120.631H91.9489V122.58H115.912V120.631Z",
    fill: "#9FAFFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M186.049 118.047V81.9214H166.573V118.047H186.049Z",
    fill: "#9FAFFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M183.631 84.3389H168.991V113.197H183.631V84.3389Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M185.052 96.3506H167.465V97.7558H185.052V96.3506Z",
    fill: "#9FAFFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M174.4 83.2964H173.07V97.4536H174.4V83.2964Z",
    fill: "#9FAFFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M180.005 83.2964H178.675V97.4536H180.005V83.2964Z",
    fill: "#9FAFFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M188.3 118.093H164.337V122.474H188.3V118.093Z",
    fill: "#E6EAFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M188.3 120.631H164.337V122.58H188.3V120.631Z",
    fill: "#9FAFFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M189.252 75.2734H89.879V81.9063H189.252V75.2734Z",
    fill: "#E6EAFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M129.631 118.214V90.8962C129.631 85.0339 134.406 80.2594 140.268 80.2594C146.13 80.2594 150.905 85.0339 150.905 90.8962V118.214H129.646H129.631Z",
    fill: "#9FAFFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M148.669 115.993H131.837V90.8962C131.837 86.2426 135.599 82.4804 140.253 82.4804C144.907 82.4804 148.669 86.2426 148.669 90.8962V115.993Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.119 94.6281V92.951H130.402V94.6281H150.119Z",
    fill: "#9FAFFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M141.265 81.3019H139.633V93.9332H141.265V81.3019Z",
    fill: "#9FAFFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M152.098 118.093H128.135V122.474H152.098V118.093Z",
    fill: "#E6EAFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M152.098 120.631H128.135V122.58H152.098V120.631Z",
    fill: "#9FAFFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M131.354 87.6326H148.684C148.684 87.6326 147.611 81.589 141.265 81.317C134.919 81.0451 131.354 87.6326 131.354 87.6326Z",
    fill: "#9FAFFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M208.168 173.679H73.9237V184.452H208.168V173.679Z",
    fill: "#9FAFFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M155.241 135.71H124.706V184.452H155.241V135.71Z",
    fill: "#5363BC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M152.098 139.11H128.135V184.452H152.098V139.11Z",
    fill: "#3E51A3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M158.716 179.073H121.518V184.452H158.716V179.073Z",
    fill: "#E6EAFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M152.023 173.679H128.15V179.058H152.023V173.679Z",
    fill: "#AEBEFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M150.119 142.026H130.402V148.613H150.119V142.026Z",
    fill: "#5363BC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M150.119 150.502H130.402V171.655H150.119V150.502Z",
    fill: "#5363BC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M146.705 158.389C147.798 158.389 148.684 157.503 148.684 156.409C148.684 155.316 147.798 154.43 146.705 154.43C145.611 154.43 144.725 155.316 144.725 156.409C144.725 157.503 145.611 158.389 146.705 158.389Z",
    fill: "#E6EAFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8679 138.943V114.482H53.6776V138.943H66.8679Z",
    fill: "#5571D8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2361 116.113H55.3245V135.65H65.2361V116.113Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1879 124.257H54.2819V125.209H66.1879V124.257Z",
    fill: "#5571D8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9809 115.418H58.0743V124.998H58.9809V115.418Z",
    fill: "#5571D8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7732 115.418H61.8666V124.998H62.7732V115.418Z",
    fill: "#5571D8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3787 138.989H52.1515V141.965H68.3787V138.989Z",
    fill: "#E6EAFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M68.3787 140.696H52.1515V142.01H68.3787V140.696Z",
    fill: "#9FAFFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M229.201 138.943V114.482H216.01V138.943H229.201Z",
    fill: "#5571D8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M227.554 116.113H217.642V135.65H227.554V116.113Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M228.506 124.257H216.599V125.209H228.506V124.257Z",
    fill: "#5571D8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M221.298 115.418H220.392V124.998H221.298V115.418Z",
    fill: "#5571D8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M225.106 115.418H224.199V124.998H225.106V115.418Z",
    fill: "#5571D8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M230.711 138.989H214.484V141.965H230.711V138.989Z",
    fill: "#E6EAFF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M230.711 140.696H214.484V142.01H230.711V140.696Z",
    fill: "#9FAFFF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64272 178.711C9.01485 178.711 11.2208 179.39 13.0792 180.569C15.1643 175.432 20.1956 171.806 26.0882 171.806C28.6567 171.806 31.0591 172.501 33.1291 173.694C35.3803 164.417 43.7206 157.543 53.6926 157.543C64.4352 157.543 73.3043 165.551 74.6641 175.915C75.2231 175.84 75.7973 175.795 76.3714 175.795C81.8409 175.795 86.4492 179.436 87.9148 184.422H-3.58618C-1.4709 180.992 2.32149 178.711 6.65782 178.711H6.64272Z",
    fill: "#1467B0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M262.274 180.463C260.189 180.463 258.24 181.068 256.593 182.11C254.75 177.577 250.308 174.374 245.11 174.374C242.844 174.374 240.714 174.979 238.885 176.051C236.906 167.862 229.518 161.773 220.724 161.773C211.236 161.773 203.394 168.844 202.2 178C201.702 177.925 201.203 177.895 200.69 177.895C195.87 177.895 191.79 181.113 190.491 185.51H271.34C269.466 182.473 266.112 180.463 262.29 180.463H262.274Z",
    fill: "#1467B0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_93_55",
    x: 0,
    y: 0,
    width: 274,
    height: 214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_55"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_55",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.47715 6.47715 1 12 1H262C267.523 1 272 5.47715 272 11V211H2V11Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyWalkthrough);
export default __webpack_public_path__ + "static/media/PropertyWalkthrough.d4eee5ce4e6831be029a21224b2e6927.svg";
export { ForwardRef as ReactComponent };